import UnitsManager from './UnitsManager';
import { UnitsVisibility } from '../types/units-visibility';

/**
 * Initialisera kartan och ladda data
 * @param {Object} params - Initialiseringsparametrar
 * @param {Object} params.mapState - MapStateManager-instans
 * @param {Object} params.drawingManager - DrawingManager-instans
 * @param {Object} params.unitsService - UnitsService-instans
 * @param {string} params.type - District type
 * @param {Object} params.match - React Router match object
 * @param {Function} params.selectArea - Callback för area selection
 * @param {Function} params.fetchSalesDistrict - Funktion för att ladda district
 * @param {Function} params.setState - React setState-funktion
 * @param {Function} params.fetch - Fetch-funktion för API-anrop
 * @returns {Promise<void>}
 */
export async function initialize({
        mapState,
        drawingManager,
        unitsService,
        type,
        match,
        selectArea,
        fetchSalesDistrict,
        setState,
        fetch
    }) {
        // 1. Initialisera mapState och drawingManager
        await initializeManagers(mapState, drawingManager, selectArea);

        // 2. Hämta units
        const units = await unitsService.fetchUnits(type);

        // 3. Uppdatera state med units
        setState({
            units,
            allUnits: units,
            mapIsLoading: false
        });

        // 4. Ladda district eller visa alla units
        if (match.params.id) {
            await fetchSalesDistrict(match.params.id, units);
        } else {
            await renderInitialUnits(units, mapState, setState, fetch);
        }
}

/**
 * Initialisera mapState och drawingManager
 * @param {Object} mapState - MapStateManager-instans
 * @param {Object} drawingManager - DrawingManager-instans
 * @param {Function} selectArea - Callback för area selection
 */
async function initializeManagers(mapState, drawingManager, selectArea) {
        // Initialisera mapState (kartans map-instans måste redan vara satt)
        // Notera: mapState.handleApiLoaded anropas redan i CreateDistrictMap innan denna metod
        // så vi behöver bara initialisera drawingManager här
        
        // Initialisera drawingManager med selectArea callback
        await drawingManager.handleApiLoaded({
            map: mapState.getMap(),
            maps: mapState.getMaps(),
            selectArea: (area) => selectArea(area, false)
        });

        // Sätt upp area click handler
        mapState.setOnAreaClick((feature) => {
            selectArea(feature);
        });
}

/**
 * Rendera initial units när inget district laddas
 * @param {Array} units - Units att rendera
 * @param {Object} mapState - MapStateManager-instans
 * @param {Function} setState - React setState-funktion
 * @param {Function} fetch - Fetch-funktion för API-anrop
 */
async function renderInitialUnits(units, mapState, setState, fetch) {
        await UnitsManager.renderUnits(
            UnitsVisibility.ALL,
            units,
            mapState.getSelectedAreas(),
            mapState,
            fetch
        );
        setState({ unitsVisible: UnitsVisibility.ALL });
}

